export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const PLUS_COUNT = "PLUS_COUNT";
export const MINUS_COUNT = "MINUS_COUNT";
export const ADD_SHIPPING_ADDRESS = "ADD_SHIPPING_ADDRESS";
export const CART_EMPTY = "CART_EMPTY";
